import { memo } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { Certificate } from '@/entities/Certificates';
import { scaleInOut } from '@/shared/lib/utils/modalTransitions';
import styles from './CertificateImageModal.module.scss';

interface CertificateImageModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  certificate: Certificate | null;
}

export const CertificateImageModal = memo(
  ({ isOpen, onOpenChange, certificate }: CertificateImageModalProps) => {
    const imageUrl = certificate?.imageFile?.url ?? null;
    const title =
      certificate?.imageFile?.name ??
      certificate?.pdfFile?.name ??
      certificate?.certificateNumber ??
      'Certificate';

    return (
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="center"
        motionProps={scaleInOut}
        size="5xl"
        classNames={{
          base: 'p-6 flex flex-col gap-4 max-w-[90vw]',
          closeButton: styles.closeBtn,
        }}
        scrollBehavior="inside"
      >
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="flex flex-col items-start gap-0">
                <span className={styles.title}>{title}</span>
              </ModalHeader>
              <ModalBody className="p-0 overflow-hidden flex items-center justify-center min-h-[400px]">
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={title}
                    className={styles.image}
                  />
                ) : (
                  <div className="py-12 text-center text-grey-secondary">
                    No image available
                  </div>
                )}
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    );
  },
);

CertificateImageModal.displayName = 'CertificateImageModal';
